export default __webpack_public_path__ + "static/media/password.091bff30.svg";